import type { ReactNode } from "react";
import { DEMO_BANNER_TEXT } from "./mock-data.js";

export function DemoBanner() {
  return (
    <div
      className="border-b border-amber-300/80 bg-amber-50 px-4 py-2 text-center text-xs font-semibold text-amber-950 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-100"
      role="status"
    >
      {DEMO_BANNER_TEXT}
    </div>
  );
}

export function BlockedChip({ label }: { label: string }) {
  return (
    <span className="inline-flex rounded-full border border-amber-300 bg-amber-50 px-2.5 py-0.5 text-[11px] font-medium text-amber-900">
      {label}
    </span>
  );
}

export function ShellPanel({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="rounded-[16px] border border-black/5 p-4">
      <div className="mb-3 flex flex-wrap items-center gap-2">
        <h3 className="text-sm font-semibold">{title}</h3>
        <BlockedChip label="Staging preview" />
      </div>
      {children}
    </section>
  );
}

export function FailureCard({ title, body }: { title: string; body: string }) {
  return (
    <div className="rounded-[16px] border border-red-200 bg-red-50 p-4 dark:border-red-900/40 dark:bg-red-950/20">
      <h3 className="text-sm font-semibold text-red-800 dark:text-red-200">{title}</h3>
      <p className="mt-1 text-sm opacity-80">{body}</p>
      <p className="mt-2 text-xs font-medium text-red-700/80">Blocked / unproven — not live</p>
    </div>
  );
}
